import SpendEvolutionCandle from "@/components/brand_portfolio/SpendEvolutionCandle";
import AppIcon from "@/components/AppIcon";
export default {
  name: "SpendEvolutionVsPrevPeriod",
  components: {
    SpendEvolutionCandle,
    AppIcon
  },
  props: {
    spendData: {
      type: Array,
      default: []
    },
    periodLength: {
      type: Number,
      default: 14
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    workspace_id: {
      type: String,
      default: ""
    },
    seller_id: {
      type: String,
      default: ""
    },
    hovering_workspace_id: {
      type: String,
      default: ""
    },
    hovering_seller_id: {
      type: String,
      default: ""
    },
    hovering_index: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      defaultData: {
        label: null,
        evol_value: 0,
        kpi_value: 0
      }
    };
  },
  computed: {
    lastestValue() {
      return this.spendData[0]?.evol_value;
    },
    arrayRowData() {
      const result = this.spendData.length > 0 ? this.spendData : Array(this.periodLength).fill({
        label: null,
        evol_value: 0,
        kpi_value: 0
      });
      return result;
    },
    maxValue() {
      const valueArray = this.arrayRowData.map(row => Math.abs(Number(row.evol_value)));
      return valueArray.length > 0 ? Math.max(...valueArray) : 0;
    }
  },
  methods: {
    displayPopover(index, hovering_workspace_id, hovering_seller_id) {
      this.$emit("displayPopover", index, hovering_workspace_id, hovering_seller_id);
    }
  }
};